<div class="banner" role="banner">
  <h1>{{ 'games.banner.title' | translate }}</h1>
</div>

<fgb-game-nav></fgb-game-nav>

<div class="container">
  <div *ngFor="let card of gameCards" class="card">
    <div class="card-header">
      <img alt="card.title" [src]="card.image" />
    </div>
    <div class="card-body">
      <h3>{{ card.title }}</h3>
      <p>{{ card.description }}</p>
      <button class="btn" (click)="navigateByURL(card.route)">{{ card.buttonLabel }}</button>
    </div>
  </div>
</div>
